﻿﻿export interface ISwapManager {
    id: number;
    name: string;
    initials: string;
    email: string;
    phoneNumber: string;
}
